import { Link } from "react-router-dom";
import { SUPPORT_WHATSAPP_LINK } from "../lib/constants";

export const Footer = () => (
  <footer className="border-t border-foreground bg-foreground text-white mt-16" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-10 grid grid-cols-1 sm:grid-cols-3 gap-8">
      <div>
        <div className="flex items-center gap-1.5">
          <div className="h-7 w-7 bg-primary flex items-center justify-center"><span className="font-display font-black text-white leading-none">W</span></div>
          <span className="font-display font-bold tracking-tight">WILTOM TradeLink</span>
        </div>
        <p className="text-sm text-white/60 mt-3 max-w-xs">B2B marketplace and transport exchange for tyres, parts and logistics across Europe.</p>
      </div>
      <div>
        <span className="label-caps text-accent">Platform</span>
        <ul className="mt-3 space-y-2 text-sm">
          <li><Link to="/marketplace" className="text-white/80 hover:text-white" data-testid="footer-marketplace">Marketplace</Link></li>
          <li><Link to="/transport" className="text-white/80 hover:text-white" data-testid="footer-transport">Transport jobs</Link></li>
          <li><Link to="/find-transporter" className="text-white/80 hover:text-white" data-testid="footer-find-transporter">Find a transporter</Link></li>
          <li><a href={SUPPORT_WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white">WhatsApp support</a></li>
        </ul>
      </div>
      <div>
        <span className="label-caps text-accent">Legal</span>
        <ul className="mt-3 space-y-2 text-sm">
          <li><Link to="/impressum" className="text-white/80 hover:text-white" data-testid="footer-impressum">Impressum</Link></li>
          <li><Link to="/datenschutz" className="text-white/80 hover:text-white" data-testid="footer-datenschutz">Datenschutzerklärung / Privacy Policy</Link></li>
          <li><Link to="/terms" className="text-white/80 hover:text-white" data-testid="footer-terms">Terms &amp; Conditions</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-4 text-xs text-white/50">© {new Date().getFullYear()} WILTOM TradeLink. All rights reserved.</div>
    </div>
  </footer>
);
